// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"45a0c2f0c5aa55080378","339":"4b9d9d5a2a685b3f3581"}[chunkId] + ".js";
};